import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ViewGridPlusOutlineIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' {...props} ref={ref}>
        <path
            fill='currentColor'
            d='M3 21h8v-8H3v8Zm2-6h4v4H5v-4Zm-2-4h8V3H3v8Zm2-6h4v4H5V5Zm8-2v8h8V3h-8Zm6 6h-4V5h4v4Zm-1 7h3v2h-3v3h-2v-3h-3v-2h3v-3h2v3Z'
        />
    </svg>
));
